import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiClient } from '../ApiClientProvider';
import { queryKeys } from '../keys';

/**
 * Re-checks the shop's Shopify plan + carrier-service eligibility (backs the
 * "Re-check plan" button on the plan-lock screen). On success the `me` query is
 * invalidated so the gate re-evaluates with the refreshed `carrier_service_eligible`.
 */
export function useRecheckPlan() {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation<void, Error, void>({
    mutationFn: () => api.post('/admin/plan/recheck'),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.me });
    },
  });
}
